import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import dateFormat from 'dateformat';
import moment from 'moment';
import Agent from '../../api/Agent';
import formatDate from '../../services/formatDate';
import { setUser, handleError, setSupervisorOrgStatus } from '../user';

import {
	getOrganizationShiftTimes,
	setShiftOrganizationID,
	setIsFetchingUserOrgData,
	getLocationShiftTimes
} from './shift';
import mixpanelConstants from '../../constants/mixpanel';

export const setsupervisordashboard = createAction('SET_SUPERVISOR_DASHBOARD');
export const setorganizations = createAction('SET_ORGANIZATIONS');
export const setlocations = createAction('SET_LOCATIONS');
export const setDepartments = createAction('SET_DEPARTMENTS');
export const setRoles = createAction('SET_ROLES');
export const setAcceptedApplicantDetail = createAction('SET_ACCEPTED_APPLICANT_DETAIL');

export const clearlocations = createAction('CLEAR_LOCATIONS');
export const cleardepartments = createAction('CLEAR_DEPARTMENTS');
export const clearstatus = createAction('CLEAR_STATUS');
export const clearsupervisors = createAction('CLEAR_SUPERVISORS');
export const clearStartDate = createAction('CLEAR_STARTDATE');
export const clearEndDate = createAction('CLEAR_ENDDATE');
export const clearRoles = createAction('CLEAR_ROLES');

export const setnotifications = createAction('SET_NOTIFICATIONS');
export const setnoticecount = createAction('SET_NOTICECOUNT');
export const setcountdisplay = createAction('SETCOUNTDISPLAY');
export const setsupervisor = createAction('SET_SUPERVISOR');
export const setuserinfo = createAction('SET_USERINFO');
export const setSupervisorsLocationID = createAction('SET_SUPERVISORS_LOCATION_ID');

export const changeStatus = createAction('CHANGE_STATUS');
export const changeLocationId = createAction('CHANGE_LOCATION_ID');
export const changeLocation = createAction('CHANGE_LOCATION');
export const changeDepartment = createAction('CHANGE_DEPARTMENT');
export const changeSupervisor = createAction('CHANGE_SUPERVISOR');
export const changeRole = createAction('CHANGE_ROLE');

export const setStartDate = createAction('SET_START_DATE');
export const setEndDate = createAction('SET_END_DATE');
export const setShiftList = createAction('SET_SHIFT_LIST');
export const setPageNumber = createAction('SET_PAGE_NUMBER');

export const clearorgList = createAction('CLEAR_ORGLIST');
export const cleardeptList = createAction('CLEAR_DEPTLIST');
export const clearlocList = createAction('CLEAR_LOCLIST');
export const clearSupervisorList = createAction('CLEAR_SUPERVISORLIST');
export const setNoticeStatus = createAction('SET_NOTICESSTATUS');

export const clearSupervisorDashboard = createAction('CLEAR_SUPERVISOR_DASHBOARD');
export const clearNotification = createAction('CLEAR_NOTIFICATION');
export const clearUserInfo = createAction('CLEAR_USERINFO');

export const setCriticalAlerts = createAction('SET_CRITICAL_ALERTS');
export const clearCriticalAlerts = createAction('CLEAR_CRITICAL_ALERTS');

export const setGeneralAlerts = createAction('SET_GENERAL_ALERTS');
export const clearGeneralAlerts = createAction('CLEAR_GENERAL_ALERTS');
export const setAlertMessage = createAction('SET_ALERT_MESSAGE');
export const setAlertExpiry = createAction('SET_ALERT_EXPIRY');
export const setAlertType = createAction('SET_ALERT_TYPE');
export const getOrgId = createAction('SET_ORG_ID');

export const setSort = createAction('SET_SORT');
export const setSortOrder = createAction('SET_SORT_ORDER');

export const setSdDayShiftList = createAction('SET_SD_DAY_SHIFT_LIST');
export const setSdWeekShiftList = createAction('SET_SD_WEEK_SHIFT_LIST');
export const setSelectedView = createAction('SET_SELECTED_VIEW');
export const setSelectedDate = createAction('SET_SELECTED_DATE');
export const setSearchString = createAction('SET_SEARCH_STRING');
export const setWeekStartDate = createAction('SET_WEEKSTART_DATE');
export const setWeekEndDate = createAction('SET_WEEKEND_DATE');
export const setDayListState = createAction('SET_DAY_LIST_STATE');
export const resetSuperDashboard = createAction('RESET_SUPERVISOR_DASHBOARD');
export const setSearchResults = createAction('SET_SEARCH_RESULTS');
export const setIsFetchingSearchResults = createAction('SET_IS_FETCHING_SEARCH_RESULTS');

export const setShiftsForQuickActions = createAction('SET_SHIFTS_FOR_QUICK_ACTIONS');

export const setIsFetchingSupervisorDashboard = createAction('SET_IS_FETCHING_SUPERVISOR_DASHBOARD');
export const setIsFetchingShiftsForQuickActions = createAction('SET_IS_FETCHING_SHIFTS_FOR_QUICK_ACTIONS');
export const setRecentQuickAcceptActions = createAction('SET_RECENT_QUICK_ACCEPT_ACTIONS');
export const setRecentQuickAcknowledgeActions = createAction('SET_RECENT_QUICK_ACKNOWLEDGE_ACTIONS');
export const setIsOpenReasonPopup = createAction('SET_IS_OPEN_REASON_POPUP');
export const setRejectShiftId = createAction('SET_REJECT_SHIFT_ID');
export const setRejectNurseId = createAction('SET_REJECT_NURSE_ID');
export const setIsFromQuickAcceptPanelSide = createAction('SET_IS_FROM_QUICK_ACCEPT_PANEL_SIDE');
export const setSupervisorNotificationStatus = createAction('SET_SUPERVISOR_NOTIFICATION_STATUS');
export const setIsPerformingActionForQA = createAction('SET_IS_PERFORMING_ACTION_FOR_QUICK_ACTIONS');
export const setOpenAlertModal = createAction('SET_OPEN_ALERT_MODAL');
export const setAlertMessageInfo = createAction('SET_ALERT_MESSAGE_INFO');
export const setCancelShiftId = createAction('SET_CANCEL_SHIFT_ID');
export const setIsOpenCancelShiftPopup = createAction('SET_IS_OPEN_CANCEL_SHIFT_POPUP');
export const setShiftCancelReason = createAction('SET_SHIFT_CANCEL_REASON');

export const setFetchingSupervisorShiftList = createAction('SET_FETCHING_SUPERVISOR_SHIFT_LIST');

export const setCAModalMessage = createAction('SET_CA_MODAL_MESSAGE');
export const setIsOpenCAModal = createAction('SET_IS_OPEN_CA_MODAL');
export const setApplicantShiftActionInfo = createAction('SET_APPLICANT_SHIFT_ACTION_INFO');

export const setAcceptedCount = createAction('SET_ACCEPTED_COUNT');
export const setShiftStartDatetime = createAction('SET_SHIFT_START_DATE_TIME');
export const setActionTakenFrom = createAction('SET_ACTION_TAKEN_FROM');
export const setSwitchBackToAdminLoading = createAction('SET_SWITCH_BACK_TO_ADMIN_LOADING');

const initialState = {
	acceptedCount: 0,
	acceptedUserDetails: [],
	actionTakenFrom: '',
	alert_expiry: 0,
	alert_message: '',
	alert_type: 0,
	alertMessageInfo: {
		message: '',
		status: 'success'
	},
	applicantShiftActionInfo: {
		applicantID: 0,
		shiftID: 0,
		shiftStatus: ''
	},
	CAModalAlertMessage: '',
	CAModalIsOpen: false,
	cancelShiftID: null,
	criticalAlertList: [],
	departments: [],
	dept: '',
	display: 'none',
	distance: '',
	from_date: '',
	generalAlertList: [],
	info: {},
	isFetching: false,
	isFetchingSearchResult: false,
	isFetchingShiftList: false,
	isFetchingShiftsForQA: false,
	isFromQuickAcceptPanelSide: false,
	isOpenCancelShiftPopup: false,
	isOpenReasonPopup: false,
	isPerformingActionForQA: false,
	isSupervisorNotificationOn: false,
	isSwitchBackToAdminLoading: false,
	loc: '',
	location_id: 0,
	locations: [],
	noticeCount: {},
	notifications: [],
	notificationStatus: 'Loading...',
	openAlertModal: false,
	org_id: 0,
	organizations: {},
	page_no: 1,
	recentQuickAcceptActions: [],
	recentQuickAcknowledgeActions: [],
	rejectNurseID: 0,
	rejectShiftID: 0,
	role: '',
	roles: [],
	sdDayListState: [],
	sdDayShiftList: [],
	sdMonthShiftList: [],
	sdWeekShiftList: [],
	searchResult: [],
	searchString: '',
	selectedDate: dateFormat(new Date(), 'yyyy-mm-dd', false),
	selectView: 'day',
	shiftCancelReason: '',
	shiftList: [],
	shiftsForQuickActions: [],
	shiftStartDateTime: '',
	sort: '',
	sortorder: '',
	status: '',
	supervisor: '',
	supervisorDashboardt: {},
	supervisors_location_id: 0,
	supervisorsList: [],
	to_date: '',
	weekEndDate: moment().endOf('week').subtract(1, 'days').toLocaleString(),
	weekStartDate: moment().startOf('week').toLocaleString(),
	zip_code: ''
};

export default handleActions(
	{
		// CLEAR_LOCLIST: (state) => ({...state, locations: initialState.locations}),
		CHANGE_DEPARTMENT: (state, action) => ({ ...state, dept: action.payload }),
		CHANGE_LOCATION: (state, action) => ({ ...state, loc: action.payload }),
		CHANGE_LOCATION_ID: (state, action) => ({ ...state, location_id: action.payload }),
		CHANGE_ROLE: (state, action) => ({ ...state, role: action.payload }),
		CHANGE_STATUS: (state, action) => ({ ...state, status: action.payload }),
		CHANGE_SUPERVISOR: (state, action) => ({ ...state, supervisor: action.payload }),
		CLEAR_CRITICAL_ALERTS: (state) => ({ ...state, criticalAlertList: initialState.criticalAlertList }),
		CLEAR_DEPARTMENTS: (state) => ({ ...state, dept: initialState.dept }),
		CLEAR_DEPTLIST: (state) => ({ ...state, departments: initialState.departments }),
		CLEAR_ENDDATE: (state) => ({ ...state, to_date: initialState.to_date }),
		CLEAR_GENERAL_ALERTS: (state) => ({ ...state, generalAlertList: initialState.generalAlertList }),
		CLEAR_LOCATIONS: (state) => ({ ...state, loc: initialState.loc }),
		CLEAR_NOTIFICATION: (state) => ({ ...state, notifications: initialState.notifications }),
		CLEAR_ORGLIST: (state) => ({ ...state, organizations: initialState.organizations }),
		CLEAR_ROLES: (state) => ({ ...state, role: initialState.role }),
		CLEAR_STARTDATE: (state) => ({ ...state, from_date: initialState.from_date }),
		CLEAR_STATUS: (state) => ({ ...state, status: initialState.status }),
		CLEAR_SUPERVISOR_DASHBOARD: (state) => ({ ...state, supervisorDashboardt: initialState.supervisorDashboardt }),
		CLEAR_SUPERVISORLIST: (state) => ({ ...state, supervisorsList: initialState.supervisorsList }),
		CLEAR_SUPERVISORS: (state) => ({ ...state, supervisor: initialState.supervisor }),
		CLEAR_USERINFO: (state) => ({ ...state, info: initialState.info }),
		RESET_SUPERVISOR_DASHBOARD: () => initialState,
		SET_ACCEPTED_APPLICANT_DETAIL: (state, action) => ({ ...state, acceptedUserDetails: action.payload }),
		SET_ACCEPTED_COUNT: (state, action) => ({ ...state, acceptedCount: action.payload }),
		SET_ACTION_TAKEN_FROM: (state, action) => ({ ...state, actionTakenFrom: action.payload }),
		SET_ALERT_EXPIRY: (state, action) => ({ ...state, alert_expiry: action.payload }),
		SET_ALERT_MESSAGE: (state, action) => ({ ...state, alert_message: action.payload }),
		SET_ALERT_MESSAGE_INFO: (state, action) => ({ ...state, alertMessageInfo: action.payload }),
		SET_ALERT_TYPE: (state, action) => ({ ...state, alert_type: action.payload }),
		SET_APPLICANT_SHIFT_ACTION_INFO: (state, action) => ({ ...state, applicantShiftActionInfo: action.payload }),
		SET_CA_MODAL_MESSAGE: (state, action) => ({ ...state, CAModalAlertMessage: action.payload }),
		SET_CANCEL_SHIFT_ID: (state, action) => ({ ...state, cancelShiftID: action.payload }),
		SET_CRITICAL_ALERTS: (state, action) => ({ ...state, criticalAlertList: action.payload }),
		SET_DAY_LIST_STATE: (state, action) => ({ ...state, sdDayListState: action.payload }),
		SET_DEPARTMENTS: (state, action) => ({ ...state, departments: action.payload }),
		SET_END_DATE: (state, action) => ({ ...state, to_date: action.payload }),
		SET_FETCHING_SUPERVISOR_SHIFT_LIST: (state, action) => ({ ...state, isFetchingShiftList: action.payload }),
		SET_GENERAL_ALERTS: (state, action) => ({ ...state, generalAlertList: action.payload }),
		SET_IS_FETCHING_SEARCH_RESULTS: (state, action) => ({ ...state, isFetchingSearchResult: action.payload }),
		SET_IS_FETCHING_SHIFTS_FOR_QUICK_ACTIONS: (state, action) => ({ ...state, isFetchingShiftsForQA: action.payload }),
		SET_IS_FETCHING_SUPERVISOR_DASHBOARD: (state, action) => ({ ...state, isFetching: action.payload }),
		SET_IS_FROM_QUICK_ACCEPT_PANEL_SIDE: (state, action) => ({ ...state, isFromQuickAcceptPanelSide: action.payload }),
		SET_IS_OPEN_CA_MODAL: (state, action) => ({ ...state, CAModalIsOpen: action.payload }),
		SET_IS_OPEN_CANCEL_SHIFT_POPUP: (state, action) => ({ ...state, isOpenCancelShiftPopup: action.payload }),
		SET_IS_OPEN_REASON_POPUP: (state, action) => ({ ...state, isOpenReasonPopup: action.payload }),
		SET_IS_PERFORMING_ACTION_FOR_QUICK_ACTIONS: (state, action) => ({
			...state,
			isPerformingActionForQA: action.payload
		}),
		SET_LOCATIONS: (state, action) => ({ ...state, locations: action.payload }),
		SET_NOTICECOUNT: (state, action) => ({ ...state, noticeCount: action.payload }),
		SET_NOTICESSTATUS: (state, action) => ({ ...state, notificationStatus: action.payload }),
		SET_NOTIFICATIONS: (state, action) => ({ ...state, notifications: action.payload }),
		SET_OPEN_ALERT_MODAL: (state, action) => ({ ...state, openAlertModal: action.payload }),
		SET_ORG_ID: (state, action) => ({ ...state, org_id: action.payload }),
		SET_ORGANIZATIONS: (state, action) => ({ ...state, organizations: action.payload }),
		SET_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_RECENT_QUICK_ACCEPT_ACTIONS: (state, action) => ({ ...state, recentQuickAcceptActions: action.payload }),
		SET_RECENT_QUICK_ACKNOWLEDGE_ACTIONS: (state, action) => ({
			...state,
			recentQuickAcknowledgeActions: action.payload
		}),
		SET_REJECT_NURSE_ID: (state, action) => ({ ...state, rejectNurseID: action.payload }),
		SET_REJECT_SHIFT_ID: (state, action) => ({ ...state, rejectShiftID: action.payload }),
		SET_ROLES: (state, action) => ({ ...state, roles: action.payload }),
		SET_SD_DAY_SHIFT_LIST: (state, action) => ({ ...state, sdDayShiftList: action.payload }),
		SET_SD_MONTH_SHIFT_LIST: (state, action) => ({ ...state, sdMonthShiftList: action.payload }),
		SET_SD_WEEK_SHIFT_LIST: (state, action) => ({ ...state, sdWeekShiftList: action.payload }),
		SET_SEARCH_RESULTS: (state, action) => ({ ...state, searchResult: action.payload }),
		SET_SEARCH_STRING: (state, action) => ({ ...state, searchString: action.payload }),
		SET_SELECTED_DATE: (state, action) => ({ ...state, selectedDate: action.payload }),
		SET_SELECTED_VIEW: (state, action) => ({ ...state, selectView: action.payload }),
		SET_SHIFT_CANCEL_REASON: (state, action) => ({ ...state, shiftCancelReason: action.payload }),
		SET_SHIFT_LIST: (state, action) => ({ ...state, shiftList: action.payload }),
		SET_SHIFT_START_DATE_TIME: (state, action) => ({ ...state, shiftStartDateTime: action.payload }),
		SET_SHIFTS_FOR_QUICK_ACTIONS: (state, action) => ({ ...state, shiftsForQuickActions: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortorder: action.payload }),
		SET_START_DATE: (state, action) => ({ ...state, from_date: action.payload }),
		SET_SUPERVISOR: (state, action) => ({ ...state, supervisorsList: action.payload }),
		SET_SUPERVISOR_DASHBOARD: (state, action) => ({ ...state, supervisorDashboardt: action.payload }),
		SET_SUPERVISOR_NOTIFICATION_STATUS: (state, action) => ({ ...state, isSupervisorNotificationOn: action.payload }),
		SET_SUPERVISORS_LOCATION_ID: (state, action) => ({ ...state, supervisors_location_id: action.payload }),
		SET_SWITCH_BACK_TO_ADMIN_LOADING: (state, action) => ({ ...state, isSwitchBackToAdminLoading: action.payload }),
		SET_USERINFO: (state, action) => ({ ...state, info: action.payload }),
		SET_WEEKEND_DATE: (state, action) => ({ ...state, weekEndDate: action.payload }),
		SET_WEEKSTART_DATE: (state, action) => ({ ...state, weekStartDate: action.payload }),
		SETCOUNTDISPLAY: (state, action) => ({ ...state, display: action.payload })
	},
	initialState
);

export const clearValues = () =>
	function (dispatch) {
		dispatch(setPageNumber(1));
		// dispatch(clearlocations())
		dispatch(cleardepartments());
		dispatch(clearstatus());
		dispatch(clearsupervisors());
		dispatch(clearStartDate());
		dispatch(clearEndDate());
		dispatch(clearRoles());
		dispatch(setIsFetchingSupervisorDashboard(true));
	};
export const pageNumber = (pageNo) =>
	function (dispatch) {
		dispatch(setPageNumber(pageNo));
		dispatch(supervisorDashboard());
	};

export const supervisorDashboard = () =>
	function (dispatch, getState) {
		let formatStartDate;
		let formatEndDate;
		const { page_no, organizations, status, role, loc, dept, supervisor, from_date, to_date, sort, sortorder } =
			getState().supervisordashboard;

		// Format start and end date to update list.
		const { dateFilterFormat } = formatDate;
		if (from_date != '') {
			formatStartDate = dateFilterFormat(from_date);
		} else {
			formatStartDate = from_date;
		}
		if (to_date != '') {
			formatEndDate = dateFilterFormat(to_date);
		} else {
			formatEndDate = to_date;
		}

		Agent.supervisorDashboard(
			page_no,
			organizations.organization_id,
			status,
			role,
			loc,
			dept,
			supervisor,
			formatStartDate,
			formatEndDate,
			sort,
			sortorder
		).then((response) => {
			if (response.ok) {
				dispatch(setsupervisordashboard(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const organization = (id) =>
	function (dispatch) {
		Agent.organizationById(id).then((response) => {
			if (response.ok) {
				dispatch(setorganizations(response.data));
				// dispatch(supervisorDashboard())
				dispatch(setlocations(response.data.locations));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const notification = () =>
	function (dispatch) {
		Agent.notices().then((response) => {
			if (response.ok) {
				dispatch(setnotifications(response.data));
				dispatch(count());
				if (response.data.length === 0) {
					dispatch(setNoticeStatus('You have no notifications.'));
				}
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const count = () =>
	function (dispatch) {
		Agent.noticeCount().then((response) => {
			if (response.ok) {
				dispatch(setnoticecount(response.data));
				if (response.data.notice_count > 0) {
					dispatch(setcountdisplay('block'));
				} else {
					dispatch(setcountdisplay('none'));
				}
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const removeNotices = (id) =>
	function (dispatch) {
		Agent.deleteNotices(id).then((response) => {
			if (response.ok) {
				dispatch(notification());
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const supervisor = (id, locid) =>
	function (dispatch) {
		Agent.supervisors(id, locid).then((response) => {
			if (response.ok) {
				dispatch(setsupervisor(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const userInfo = () =>
	function (dispatch, getState) {
		Agent.userinfo().then((response) => {
			if (response.ok) {
				dispatch(setUser(response.data));
				dispatch(setuserinfo(response.data));
				dispatch(setShiftOrganizationID(response.data.user_orgs[0].organization_id));
				dispatch(organization(response.data.user_orgs[0].organization_id));
				dispatch(setSupervisorOrgStatus(response.data.user_orgs[0].organization_status));
				dispatch(setIsFetchingUserOrgData(false));
				dispatch(setSupervisorsLocationID(response.data.user_orgs[0].location_id));
				// dispatch(supervisor(response.data.user_orgs[0].organization_id,'NA'))
				// dispatch(getCriticalalerts(response.data.user_orgs[0].organization_id,1))
				// dispatch(getGeneralalerts(response.data.user_orgs[0].organization_id,0))
				// dispatch(getOrgId(response.data.user_orgs[0].organization_id))
				// dispatch(changeLocationId(response.data.user_orgs[0].location_id))
				if (getState().supervisordashboard.selectView == 'day') {
					dispatch(supervisorDashboardDayList());
				}
				localStorage.setItem('shift_manager', (!!response.data.shift_manager).toString());
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getShiftTimes = (isLocShiftTimeFeatureActive, location_id, organization_id) =>
	function (dispatch) {
		// This should be cleaned up when we are done with the release of custom shift times
		if (isLocShiftTimeFeatureActive) {
			dispatch(getLocationShiftTimes(location_id, organization_id));
		} else {
			dispatch(getOrganizationShiftTimes(organization_id));
		}
	};

export const roles = () =>
	function (dispatch) {
		Agent.roleOptions().then((response) => {
			if (response.ok) {
				dispatch(setRoles(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const acceptedApplicantDetails = (id) =>
	function (dispatch) {
		Agent.getAcceptedShiftApplicant(id).then((response) => {
			if (response.ok) {
				dispatch(setAcceptedApplicantDetail(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getCriticalalerts = (id, priority) =>
	function (dispatch) {
		Agent.getAlert(id, priority).then((response) => {
			if (response.ok) {
				dispatch(setCriticalAlerts(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getGeneralalerts = (id, priority) =>
	function (dispatch) {
		Agent.getAlert(id, priority).then((response) => {
			if (response.ok) {
				dispatch(setGeneralAlerts(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const createAlert = () =>
	function (dispatch, getState) {
		const { organizations, loc, locations, dept, departments, alert_message, alert_expiry, alert_type } =
			getState().supervisordashboard;
		const loc_int = parseInt(loc);
		const dept_int = parseInt(dept);
		const expiration_date = parseInt(alert_expiry);

		Agent.createAlert(
			organizations.organization_id,
			loc_int,
			dept_int,
			alert_type,
			alert_message,
			expiration_date
		).then((response) => {
			dispatch(changeLocation(''));
			dispatch(changeDepartment(''));
			if (response.ok) {
				if (alert_type == 0) {
					dispatch(getGeneralalerts(organizations.organization_id, alert_type));
				} else if (alert_type == 1) {
					dispatch(getCriticalalerts(organizations.organization_id, alert_type));
				}

				const locationName = locations.filter((l) => l.location_id == loc_int)[0];
				const departmentName = departments.filter((d) => d.department_id == dept_int)[0];
				const alertType = alert_type == 1 ? 'critical' : 'general';
				mixpanel.track(mixpanelConstants.ADD_NEW_ALERT, {
					department: departmentName,
					location: locationName,
					message: alert_message,
					organization: organizations.title,
					type: alertType
				});
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const supervisorDashboardDayList = (searchString) => {
	if (searchString == undefined) {
		searchString = '';
	}
	return function (dispatch, getState) {
		let org_id = 0;
		if (getState().supervisordashboard.info.user_orgs != undefined) {
			org_id = getState().supervisordashboard.info.user_orgs[0].organization_id;
		}
		let loc_id = '';
		if (getState().supervisordashboard.location_id > 0) {
			loc_id = getState().supervisordashboard.location_id;
		}
		dispatch(setFetchingSupervisorShiftList(true));
		Agent.supervisorDashboardDay(org_id, loc_id, getState().supervisordashboard.selectedDate, searchString).then(
			(response) => {
				if (response.ok) {
					const dayViewState = [];
					response.data.forEach((s, index) => {
						response.data[index].showAll = false;
						response.data[index].fullNotes = false;
						const object = {
							isVisible: true
						};
						dayViewState.push(object);
					});
					dispatch(setSdDayShiftList(response.data));
					dispatch(setDayListState(dayViewState));
				} else {
					dispatch(handleError(response));
				}
				dispatch(setIsFetchingSupervisorDashboard(false));
				dispatch(setFetchingSupervisorShiftList(false));
			}
		);
	};
};

// supervisor dashboard search result api
export const getSearchResults = (search_str) =>
	function (dispatch, getState) {
		if (!search_str || search_str == ' ') {
			dispatch(setSearchResults([]));
			return;
		}

		let org_id = 0;
		if (getState().supervisordashboard.info.user_orgs != undefined) {
			org_id = getState().supervisordashboard.info.user_orgs[0].organization_id;
		}
		const min = 1;
		const max = 100;
		const rand = Math.round(min + Math.random() * (max - min));
		dispatch(setIsFetchingSearchResults(true));
		Agent.supervisorShiftSearch(org_id, search_str, rand).then((response) => {
			if (response.ok) {
				if (rand == parseInt(response.data.api_req_id)) {
					if (response.data.super_shifts != null) {
						dispatch(setSearchResults(response.data.super_shifts));
					} else {
						dispatch(setSearchResults([]));
					}
				}
			} else {
				dispatch(handleError(response));
			}
			dispatch(setIsFetchingSearchResults(false));
		});
	};

// supervisor dashboard get shifts for quick actions
export const getShiftsForQuickActions = () =>
	function (dispatch, getState) {
		dispatch(setIsFetchingShiftsForQuickActions(true));

		let org_id = 0;
		if (getState().supervisordashboard.info.user_orgs != undefined) {
			org_id = getState().supervisordashboard.info.user_orgs[0].organization_id;
		}
		let loc_id = '';
		if (getState().supervisordashboard.location_id > 0) {
			loc_id = getState().supervisordashboard.location_id;
		}

		Agent.supervisorShiftsForQuickActions(org_id, loc_id).then((response) => {
			if (response.ok) {
				dispatch(setShiftsForQuickActions(response.data));
			} else {
				dispatch(handleError(response));
			}
			dispatch(setIsFetchingShiftsForQuickActions(false));
		});
	};
